<template>
    <Head title="پرداخت سفارش"/>
    <breadcrumb :links="[{title: 'پرداخت سفارش'}]"/>
    <section class="py-4">
        <div class="container">

            <div class="row g-4">
                <div class="col-lg-7">
                    <ul class="list-unstyled vstack gap-3">
                        <li v-for="product in billItemsBasedOnProduct" class="card card-body">
                            <a :href="product.url" class="hstack gap-3 align-items-start mb-3">
                                <img v-if="product.image" :src="product.image.url['90x90']" :alt="product.title"
                                     class="rounded img-fluid" width="90" height="90">
                                <div class="flex-fill">
                                    <h5 class="fw-bold">{{ product.title }}</h5>
                                    <h6 class="text-dark">{{ product.subtitle }}</h6>
                                </div>
                            </a>

                            <ul class="list-group border-0">
                                <li v-for="item in product.states"
                                    class="list-group-item hstack gap-3 bg-light border-0">
                                    <div class="flex-fill fw-bold">{{ item.title }}</div>
                                    <div class="fw-bold">{{ toFaNum(item.price) }} تومان</div>
                                    <div class="">{{ toFaNum(item.count) }} عدد</div>

                                </li>
                            </ul>

                        </li>
                    </ul>
                </div>
                <div class="col-lg-5">
                    <div v-if="timer > 0" class="card bg-light card-body p-4 vstack gap-3">
                        <div class="badge bg-white text-body">{{ toFaNum(timer) }} ثانیه برای پرداخت سفارش مهلت دارید
                        </div>
                        <div v-if="bill.discount_data" class="hstack justify-content-between gap-2 fw-bold">
                            <div>
                                تخفیف
                            </div>
                            <div class="text-end">تومان {{ toFaNum(bill.discount_data.reward) }}</div>
                        </div>

                        <div class="hstack justify-content-between gap-2 fw-bolder">
                            <div>
                                مبلغ قابل پرداخت
                            </div>
                            <div class="text-end fs-5">تومان {{ toFaNum(bill.price) }}</div>
                        </div>

                        <div class="hstack gap-2 justify-content-center">
                            <div
                                :class="form.gateway === 'behpardakht' ? 'border border-2 border-primary rounded p-2' : 'p-2'">
                                <label>
                                    <input v-model="form.gateway" class="position-absolute opacity-0" name="gateway"
                                           type="radio" value="behpardakht">
                                    <img height="90" src="/images/gateway-logo-behpardakht.svg" alt="به پرداخت ملت">
                                </label>
                            </div>
                            <div
                                :class="form.gateway === 'zarinpal' ? 'border border-2 border-primary rounded p-2' : 'p-2'">
                                <label>
                                    <input v-model="form.gateway" class="position-absolute opacity-0" name="gateway"
                                           type="radio" value="zarinpal">
                                    <img height="90" src="/images/gateway-logo-zarinpal.png" alt="زرین پال">
                                </label>
                            </div>
                        </div>

                        <div class="form-check">
                            <input v-model="form.rules" class="form-check-input" type="checkbox" value="" id="rules-checkbox">
                            <label class="form-check-label" for="rules-checkbox">
                                من
                                <a href="https://iranget.com/page/rules" target="_blank" class="text-primary">
                                    شرایط و مقررات
                                </a>
                                سایت را خوانده‌ام و آن را می‌پذیرم.
                            </label>
                            <div v-if="form.errors.rules" class="invalid-feedback d-block fw-bold">
                                برای ادامه باید شرایط و مقررات سایت را بپذیرید!
                            </div>
                        </div>



                        <div v-if="form.errors.captcha_token" class="invalid-feedback d-block fw-bold">
                            {{ form.errors.captcha_token }}
                        </div>

                        <button @click.prevent="createPayment"
                                class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold w-100 fs-6 py-3">

                            پرداخت

                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.85288 8.95043C4.50437 6.17301 6.67301 4.00437 9.45043 3.35288C11.4563 2.88237 13.5437 2.88237 15.5496 3.35288C18.327 4.00437 20.4956 6.17301 21.1471 8.95044C21.6176 10.9563 21.6176 13.0437 21.1471 15.0496C20.4956 17.827 18.327 19.9956 15.5496 20.6471C13.5437 21.1176 11.4563 21.1176 9.45044 20.6471C6.67301 19.9956 4.50437 17.827 3.85288 15.0496C3.38237 13.0437 3.38237 10.9563 3.85288 8.95043Z"
                                    stroke="white" stroke-width="1.5"/>
                                <path d="M16 12L9 12M9 12L11.5 14.5M9 12L11.5 9.5" stroke="white" stroke-width="1.5"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                        </button>

                    </div>
                    <div v-else class="card bg-primary text-white card-body p-4 vstack gap-3">
                        <h5>سفارش شما منقضی شده است. لطفا مجددا نسبت به ثبت سفارش اقدام فرمایید</h5>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import jmoment from "moment-jalaali";
import Breadcrumb from "../../Components/Breadcrumb";
import {Head, useForm} from "@inertiajs/inertia-vue3";
import {useReCaptcha} from 'vue-recaptcha-v3';

export default {
    components: {
        Breadcrumb,
        Head,
    },
    props: {
        bill: {
            type: Object,
        }
    },
    setup(props) {
        const form = useForm({
            gateway: 'behpardakht',
            captcha_token: null,
            rules: false,
        })

        const {executeRecaptcha, recaptchaLoaded} = useReCaptcha()

        const createPayment = async () => {
            // await recaptchaLoaded()
            // form.captcha_token = await executeRecaptcha('createPayment')
            form.captcha_token = 'x'
            form.post('/checkout/' + props.bill.uuid)
        }

        return {form, createPayment}
    },
    data() {
        return {
            timer: null,
        }
    },
    computed: {
        billItemsBasedOnProduct() {
            let products = []
            this.bill.billItems.forEach((billItem) => {
                let productIndex = products.findIndex(product => product.id === billItem.state.product.id)
                if (productIndex === -1) {
                    let product = {
                        id: billItem.state.product.id,
                        title: billItem.description.product_title,
                        subtitle: billItem.description.product_subtitle,
                        url: billItem.state && billItem.state.product ? billItem.state.product.url : '#',
                        image: billItem.state && billItem.state.product && billItem.state.product.image ? billItem.state.product.image : null,
                        states: [
                            {
                                count: billItem.count,
                                title: billItem.description.state_title,
                                price: billItem.price,
                            }
                        ],
                    }
                    products.push(product)
                } else {
                    products[productIndex].states.push({
                        count: billItem.count,
                        title: billItem.description.state_title,
                        price: billItem.price,
                    })
                }
            })
            return products
        },
    },
    mounted() {
        let vm = this
        vm.timer = parseInt(jmoment.duration(jmoment(vm.bill.expire_at).diff(jmoment())).asSeconds())
        setInterval(function () {
            vm.timer = parseInt(jmoment.duration(jmoment(vm.bill.expire_at).diff(jmoment())).asSeconds())
        }, 1000)
    }

}
</script>

<style scoped>

</style>
